import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  CadernoSumarioPublicacaoHtmlOutputDto,
  FiltroSumarioPublicacaoHtml,
  GrupoSumarioPublicacaoHtmlOutputDto,
  SecaoSumarioPublicacaoHtmlOutputDto
} from 'src/app/domain/DTOs/output/publicacao/sumario-publicacao-html-output.dto';

@Component({
  selector: 'app-sumario-publicacao-html',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sumario-publicacao-html.component.html',
  styleUrl: './sumario-publicacao-html.component.css'
})
export class SumarioPublicacaoHtmlComponent implements OnChanges {
  @Input({ required: true }) edicaoId!: number;
  @Input({ required: true }) caderno!: CadernoSumarioPublicacaoHtmlOutputDto;
  @Input() filtroSelecionado?: FiltroSumarioPublicacaoHtml;
  @Output() filtroAlterado = new EventEmitter<FiltroSumarioPublicacaoHtml>();

  public grupoSelecionado?: GrupoSumarioPublicacaoHtmlOutputDto;
  public secaoSelecionadaId?: number;

  public ngOnChanges(): void {
    const grupoId = this.filtroSelecionado?.entidadeId ?? this.filtroSelecionado?.municipioId;
    this.grupoSelecionado = this.caderno.grupos.find(grupo => grupo.id === grupoId);
    this.secaoSelecionadaId = this.filtroSelecionado?.secaoId;
  }

  public get possuiGrupos(): boolean {
    return this.caderno.grupos.length > 0;
  }

  public get rotuloGrupo(): string {
    return this.caderno.cadernoId === 2 ? 'Selecione o município:' : 'Selecione o órgão:';
  }

  public get secoesDisponiveis(): SecaoSumarioPublicacaoHtmlOutputDto[] {
    return this.possuiGrupos ? this.grupoSelecionado?.secoes ?? [] : this.caderno.secoes;
  }

  public selecionarGrupo(event: Event): void {
    const id = Number((event.target as HTMLSelectElement).value);
    this.grupoSelecionado = this.caderno.grupos.find(grupo => grupo.id === id);
    this.secaoSelecionadaId = undefined;
    this.emitirFiltro();
  }

  public selecionarSecao(event: Event): void {
    this.secaoSelecionadaId = Number((event.target as HTMLSelectElement).value) || undefined;
    this.emitirFiltro(this.secaoSelecionadaId);
  }

  private emitirFiltro(secaoId?: number): void {
    const filtro: FiltroSumarioPublicacaoHtml = {
      edicaoId: this.edicaoId,
      cadernoEdicaoId: this.caderno.cadernoEdicaoId,
      secaoId
    };

    if (this.grupoSelecionado) {
      if (this.caderno.cadernoId === 2)
        filtro.municipioId = this.grupoSelecionado.id;
      else
        filtro.entidadeId = this.grupoSelecionado.id;
    }

    this.filtroAlterado.emit(filtro);
  }
}
